<div class="container dialog-container">
  <h2 class="display-6" *ngIf="!speciesForm.get('species')?.value">Add Species</h2>
  <h2 class="display-6" *ngIf="speciesForm.get('species')?.value">Edit Species</h2>

  <!-- Add / Edit Species Form -->
  <form [formGroup]="speciesForm">
    <div class="row">
      <mat-form-field>
        <mat-label>Species Name</mat-label>
        <input matInput
               placeholder="Select species"
               [matAutocomplete]="auto"
               formControlName="species"
               #speciesInput>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySpecies.bind(this)">
          <mat-option *ngFor="let option of filteredSpecies | async" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="speciesForm.get('species')!.invalid && speciesForm.get('species')!.touched">
          Select an item
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>Pounds Landed</mat-label>
        <input matInput
               type="text"
               inputmode="decimal"
               formControlName="poundsLanded"
               required
               pattern="[0-9]*"
               (keydown)="preventInvalidInput($event)">
        <mat-error *ngIf="speciesForm.get('poundsLanded')?.hasError('required') && speciesForm.get('poundsLanded')?.touched">
          Enter a number
        </mat-error>
        <mat-error *ngIf="speciesForm.get('poundsLanded')?.hasError('min')">
          Pounds Landed cannot be less than 0.
        </mat-error>
        <mat-error *ngIf="speciesForm.get('poundsLanded')?.hasError('max')">
          Pounds Landed cannot be more than 400000.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row" style="padding-top: 20px;">
      <mat-form-field>
        <mat-label>Landing Receipt Number</mat-label>
        <input matInput type="text" formControlName="landingReceiptNumber">
        <mat-error *ngIf="speciesForm.get('landingReceiptNumber')?.errors?.ticket">
          {{ speciesForm.get('landingReceiptNumber')?.errors?.ticket.error }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <br />

  <!-- Delete Button (only shown when editing an existing species) -->
  <div class="top-right" *ngIf="speciesForm.get('species')?.value">
    <button mat-mini-fab class="blue-icon-button" style="background-color: white; color: #005d87"
            aria-label="Delete Species" (click)="deleteSpecies()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <!-- Bottom Buttons -->
  <div class="buttons">
    <button mat-fab class="text-blue-button" type="button" aria-label="Back" (click)="closeDialog()">
      Cancel
    </button>
    <button mat-fab class="text-button" type="button" aria-label="Add Species" (click)="addSpecies()">
      OK
    </button>
  </div>
</div>
